import xmlIcon from '@/assets/xml.svg';

export const XmlIcon = () => <img src={xmlIcon} alt="xml Icon" className="w-4 h-4 mr-2" />;
